// TEI Client
// Client for Hugging Face Text Embeddings Inference (TEI)

import { createTeiUtils } from './utils.js'

/**
 * Create TEI client
 * @param {Function} httpRequest - HTTP request function
 * @returns {Object} TEI client
 */
export function createTeiClient(httpRequest) {
  const { requestAPI, checkAvailability } = createTeiUtils(httpRequest)

  const embed = async ({ texts, endpoint }) => {
    const isString = typeof texts === 'string'
    const inputs = isString ? [texts] : texts

    if (!Array.isArray(inputs) || inputs.length === 0) {
      throw new Error('texts must be a non-empty string or array of strings')
    }

    const response = await requestAPI({
      endpoint,
      path: '/embed',
      method: 'POST',
      body: { inputs },
    })

    if (!Array.isArray(response)) {
      throw new Error('Invalid response from TEI: expected array of embeddings')
    }

    return isString ? response[0] : response
  }

  const info = async ({ endpoint }) => {
    return await requestAPI({
      endpoint,
      path: '/info',
      method: 'GET',
    })
  }

  const health = async ({ endpoint }) => {
    return await checkAvailability(endpoint)
  }

  const metrics = async ({ endpoint }) => {
    return await requestAPI({
      endpoint,
      path: '/metrics',
      method: 'GET',
    })
  }

  return {
    embed,
    info,
    health,
    metrics,
    checkAvailability,
  }
}
